<div
  class="register-form"
  *ngIf="isLoggedOut">
  <h1 class="register-form__title mb-2">
    {{ ("registration" | i18n) || "Registrierung" }}
  </h1>
  <div
    class="register-form__stepper-page"
    [class.step-active]="stepperPage == 1">
    <p>
      {{
        ("createAccountHelpText" | i18n) ||
          "Bitte erstelle einen kostenlosen Account, um in unseren Notfall-Pool aufgenommen werden zu können."
      }}
    </p>

    <button
      mat-button
      class="mat-button-block"></button>

    <button
      mat-button
      type="button"
      class="register-form__provider-button register-form__provider-button--email"
      (click)="onProviderEmailClick()">
      {{
        ("registerWithEmail" | i18n) || "Mit E-Mail Registrieren" | uppercase
      }}
    </button>
  </div>
  <div
    class="register-form__stepper-page"
    [class.step-active]="stepperPage == 2">
    <form
      class="register-form__form"
      (ngSubmit)="registerWithEmail()">
      <mat-form-field>
        <mat-label>{{ ("email" | i18n) || "E-Mail" }}</mat-label>
        <input
          matInput
          [(ngModel)]="email"
          type="email"
          autofocus
          required
          name="registerEmail"
          autocomplete="username" />
      </mat-form-field>
      <button
        mat-button
        [disabled]="!email || showLoadingIndicator"
        color="primary"
        type="submit"
        class="mat-button-block">
        <span>
          <mat-spinner
            *ngIf="showLoadingIndicator"
            diameter="16"
            class="loadingSpinner">
          </mat-spinner>
          {{ ("continue" | i18n) || "registrieren" | titlecase }}
        </span>
      </button>
    </form>
  </div>
</div>
